import React, { useEffect, useState } from "react";
import { api, CONFORMITE_COLORS } from "../lib/api";
import { ShieldCheck, AlertTriangle, XCircle, HelpCircle } from "lucide-react";

const STATUS_META = {
  VERT: { icon: ShieldCheck, label: "Conforme", cls: "text-emerald-600" },
  ORANGE: { icon: AlertTriangle, label: "Pièce bientôt expirée", cls: "text-amber-600" },
  ROUGE: { icon: XCircle, label: "Incomplet / non exploitable", cls: "text-red-600" },
  GRIS: { icon: HelpCircle, label: "Non vérifié", cls: "text-slate-500" },
};

export default function Subcontractors() {
  const [subs, setSubs] = useState([]);

  useEffect(() => {
    api.get("/contacts", { params: { categorie: "sous-traitant" } }).then((r) => setSubs(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-5" data-testid="subcontractors-page">
      <h1 className="font-display text-3xl font-extrabold uppercase tracking-tight">Sous-traitants & Prestataires</h1>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {Object.entries(STATUS_META).map(([k, m]) => (
          <div key={k} className="bg-card rounded-xl border border-border p-3 flex items-center gap-2" data-testid={`legend-${k.toLowerCase()}`}>
            <span className={`${CONFORMITE_COLORS[k]} h-3 w-3 rounded-full`} />
            <span className="text-xs font-bold">{k} — {m.label}</span>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3" data-testid="subcontractors-list">
        {subs.map((s) => {
          const meta = STATUS_META[s.statut_conformite || "GRIS"];
          return (
            <div key={s.id} className="bg-card rounded-xl border-2 border-border p-4 space-y-2" data-testid={`subcontractor-${s.id}`}>
              <div className="flex items-start justify-between gap-2">
                <div>
                  <div className="font-bold">{s.nom_commercial || s.raison_sociale}</div>
                  <div className="text-xs text-muted-foreground">{s.raison_sociale}</div>
                </div>
                <div className={`flex items-center gap-1.5 font-bold text-xs uppercase ${meta.cls}`}>
                  <span className={`${CONFORMITE_COLORS[s.statut_conformite || "GRIS"]} h-4 w-4 rounded-full`} />
                  {s.statut_conformite || "GRIS"}
                </div>
              </div>
              {s.siren && <div className="text-xs font-mono-num">SIREN {s.siren}</div>}
              <div className="text-xs text-muted-foreground">{s.adresse}</div>
              {s.secteur && <div className="text-sm">{s.secteur}</div>}
              {s.reference_interne && <div className="text-[10px] font-mono-num text-muted-foreground">Réf. interne : {s.reference_interne}</div>}
              {s.conformite_notes && (
                <div className="bg-red-50 dark:bg-red-950 border border-red-300 dark:border-red-800 rounded-lg p-3 text-xs font-semibold" data-testid={`conformite-notes-${s.id}`}>
                  {s.conformite_notes}
                </div>
              )}
              {s.tarifs_notes && <div className="bg-muted rounded-lg p-3 text-xs">{s.tarifs_notes}</div>}
              <div className="text-[10px] text-muted-foreground">Source : {s.source_contact}</div>
            </div>
          );
        })}
        {subs.length === 0 && <p className="text-sm text-muted-foreground" data-testid="subs-empty">Aucun sous-traitant référencé.</p>}
      </div>
    </div>
  );
}
